module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAX0lEQVQ4T2Os2fH/DQMDgzADeeAtY82O//9bPBgZydEP0ovXgJod/y+DDG7xYNTFZgExBvyHGoDVhcPNAGiA6RAZG1dAAYsSBhQbgCuaRlIs4AgDypIyoSiFRSNF2RkA/nmfC/tWL9MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add.png
// module id = QBcd
// module chunks = 0